var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagHonduras(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4307C24.8366 32.4307 32 25.2672 32 16.4307C32 7.59411 24.8366 0.430664 16 0.430664C7.16344 0.430664 0 7.59411 0 16.4307C0 25.2672 7.16344 32.4307 16 32.4307Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 32.4307C22.3436 32.4307 27.8246 28.7391 30.4126 23.3872H1.58789C4.17589 28.7391 9.65689 32.4307 16.0003 32.4307Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 0.430664C9.65689 0.430664 4.17589 4.12223 1.58789 9.47416H30.4126C27.8246 4.12223 22.3436 0.430664 16.0003 0.430664Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84683 10.8652L10.3648 12.4595H12.0411L10.685 13.4448L11.2031 15.0391L9.84683 14.0538L8.49058 15.0391L9.00864 13.4448L7.65245 12.4595H9.32876L9.84683 10.8652Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84683 17.8218L10.3648 19.4162H12.0411L10.685 20.4014L11.2031 21.9957L9.84683 21.0103L8.49058 21.9957L9.00864 20.4014L7.65245 19.4162H9.32876L9.84683 17.8218Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1534 10.8652L22.6714 12.4595H24.3477L22.9915 13.4448L23.5096 15.0391L22.1534 14.0538L20.7971 15.0391L21.3152 13.4448L19.959 12.4595H21.6354L22.1534 10.8652Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1534 17.8218L22.6714 19.4162H24.3477L22.9915 20.4014L23.5096 21.9957L22.1534 21.0103L20.7971 21.9957L21.3152 20.4014L19.959 19.4162H21.6354L22.1534 17.8218Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 14.3438L16.5183 15.9381H18.1946L16.8385 16.9234L17.3565 18.5176L16.0003 17.5323L14.644 18.5176L15.1621 16.9234L13.8059 15.9381H15.4822L16.0003 14.3438Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.430664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagHonduras);
export default __webpack_public_path__ + "static/media/flag_honduras.d397bc01c1fd2d9a82e9acb0dd8c6173.svg";
export { ForwardRef as ReactComponent };